import { ArrowLeft } from 'lucide-react';

interface AttendanceHeaderProps {
  onBack?: () => void;
}

export function AttendanceHeader({ onBack }: AttendanceHeaderProps) {
  return (
    <div className="flex items-center gap-3 px-4 py-4 border-b border-gray-100">
      {onBack && (
        <button
          onClick={onBack}
          className="p-2 hover:bg-gray-100 rounded-full transition-colors"
        >
          <ArrowLeft className="w-5 h-5 text-gray-600" />
        </button>
      )}
      <h1 className="text-lg font-semibold text-gray-800">任务型考勤</h1>
    </div>
  );
}
